import {useMemo} from 'react';
import {useFormContainerContext} from '@/components/help/common/FormContainer/FormContainerContext';
import {FORM_LABEL} from '@/constants/help/index';

export const useFormLabels = () => {
  const {type} = useFormContainerContext();
  const base = FORM_LABEL[type];

  return useMemo(
    () => ({
      mainCategoryType: `${base} 유형`,
      title: `${base}`,
      content: `${base} 내용`,
      cautionTitle: `${base} 유의사항`,
      submit: `${base}하기`,
    }),
    [base],
  );
};
